import moment from "moment"

const IDNumberFormatter = Intl.NumberFormat('ID', {
  style: 'currency',
  currency: 'IDR',
})

export const formatValue = (value, format) => {
  if (value === null || value === undefined || value === "")
    return ""
    
  if (!format)
    return value
  
  let formatArr = format.split("|")  
  const type = formatArr[0]
  const param = formatArr.length > 1 && formatArr[1]
    
  if (type == 'currency') {
    return IDNumberFormatter.format(
       Number.parseFloat(value).toFixed(0)
      ).replace(",00", "") 
  }
  else if (type == 'percent') {
    let p = Math.floor(value * 100)
    return `${p}%`
  }
  else if (type == 'datetime') {
    if (param == "fromnow")
      return moment(value).fromNow()
    if(param == "daysuntilnow"){
      const daysDifference = moment().diff(moment(value), "days")
      return daysDifference == 1 ? `${daysDifference} day` : `${daysDifference} days`
    }
    else if (param == "relative" || param == "relative-long") {
      const time = moment(value)    
      if (time.isSame(new Date(), "day"))
        return time.format("HH:mm")
      else if (time.isSame(moment().subtract(1, 'days'), "day")) {
        if (param == "relative-long")
          return "Yesterday " + time.format("HH:mm")
        return "Yesterday"
      }
      else {
        if (param == "relative-long")        
          return time.format("DD MMM yyy HH:mm")
        return time.format("DD MMM yyy")
      }
    }
    else if (param === 'template-format') {
      const time = moment(value)    
      const today = moment().startOf('day');
      const tomorrow = moment().add(1, 'day').startOf('day');
      const yesterday = moment().subtract(1, 'day').startOf('day');
      const timeDay = time.clone().startOf('day');

      // Tentukan label hari
      let dayLabel = '';
      
      if (timeDay.isSame(today)) {
        dayLabel = 'Today';
      } else if (timeDay.isSame(tomorrow)) {
        dayLabel = 'Tomorrow';
      } else if (timeDay.isSame(yesterday)) {
        dayLabel = 'Yesterday';
      }

      // Format: "today, 06/10/2025 04:55"
      const date = dayLabel ? time.format('HH:mm') : time.format('DD MMM yyy HH:mm');
      return `${dayLabel ? `${dayLabel}, `: ''}${date}`;
    }

    return moment(value).format(param || "LL")
  }
  else if (type == 'duration') {
    if (!value || isNaN(value) || value < 0) return "–"
    const d = Math.floor(value / 86400)
    const h = Math.floor((value % 86400) / 3600)
    const m = Math.floor((value % 3600) / 60)
    const s = value % 60
    const parts = []
    if (d) parts.push(`${d} day${d !== 1 ? 's' : ''}`)
    if (h) parts.push(`${h} hour${h !== 1 ? 's' : ''}`)
    if (m) parts.push(`${m} minute${m !== 1 ? 's' : ''}`)
    if (s || parts.length === 0) parts.push(`${s} second${s !== 1 ? 's' : ''}`)
    return parts.join(' ')
  }
  else if (type == 'duration-short') {
    if (!value || isNaN(value) || value < 0) return "–"
    const d = Math.floor(value / 86400)
    const h = Math.floor((value % 86400) / 3600)
    const m = Math.floor((value % 3600) / 60)
    const parts = []
    if (d) parts.push(`${d}d`)
    if (h) parts.push(`${h}h`)
    if (m || (!d && !h)) parts.push(`${m}m`)
    return parts.join(' ')
  }
  return value
}

export default formatValue